define((require) => {
    "use strict";

    const AddVariantAction      = require("ui/actions/AddVariantAction");
    const EditorEvents          = require("shared/services/EditorEvents");
    const LocalizationGroup     = require("shared/services/localization/LocalizationGroup");
    const LocaleCollection      = require("shared/services/localization/LocaleCollection");
    const SharedEntityType      = require("ui/experienceOverview/experiencePermissions/SharedEntityType");
    const SharedEntityHelper    = require("ui/experienceOverview/experiencePermissions/SharedEntityHelper");

    /**
     * An action that either creates a new localization group or adds an new variant to the existing group.
     *
     * @class AddLocaleAction
     *
     */
    return AddVariantAction.extend({

        localeString: null,

        constructor(group, experience, project, localeString) {
            this.__super(group, experience, project);

            this.localeString = localeString;
        },

        _performExecution() {
            const locale = LocaleCollection.findByLocaleString(this.localeString);
            const experience = this._experience;
            let clone = null;

            if (this._group) {
                clone = experience.clone({duplicate: true});
                clone.set({"name": experience.get("name") + " (new)"});

                return clone.save()
                    .then(() => {
                        this._trackVariant(EditorEvents.constants.CREATE_VARIANT, {
                            experience: clone,
                            triggerOrigin: "AddLocaleVariantIcon"
                        });

                        this._group.attach(clone, locale);

                        return clone;
                    });
            }

            this._group = new LocalizationGroup({name: experience.get("name") + " group"});

            return this._group
                .attach(experience, locale)
                .then(() => {
                    // If inside the project context - attach the group to the current project.
                    if (this._project) {
                        return this._project
                            // Fetch to ensure project model is in sync (avoiding potential version conflicts).
                            .fetch()
                            .then(() => this._project.attach(this._group));
                    }
                })
                .then(() => {
                    this._trackVariant(EditorEvents.constants.CREATE_GROUP, {
                        experience: clone || this._experience,
                        triggerOrigin: "CreateLocalizationGroupDropdown"
                    });

                    return this._group;
                })
                .then(() => {
                    SharedEntityHelper.movePermissions({
                        sourceID: clone.get("id"),
                        sourceType: SharedEntityType.EXPERIENCE,
                        companyId: clone.get("companyId"),
                        destID: this._group.get("id"),
                        destType: SharedEntityType.GROUP
                    });
                });
        },


        /**
         * Sends Mix Panel event for the variant.
         *
         * @param {String} eventName The name of the event.
         * @param {Object} payload Object containing mandatory properties for the tracking method.
         * @param {ExperienceModel} payload.experience The `ExperienceModel` instance.
         * @param {String} payload.triggerOrigin The `triggerOrigin` used for tracking.
         */
        _trackVariant(eventName, {experience, triggerOrigin}) {
            const eventProperties = {
                locale: this.localeString,
                projectId: this._project && this._project.get("id"),
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                triggerOrigin,
                groupId: this._group.id,
                groupType: this._group.get("type"),
                groupVersion: this._group.get("version"),
                groupPushedVersion: this._group.get("pushedVersion")
            };

            EditorEvents.trigger(eventName, eventProperties);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/AddLocaleAction.js